<template>
    <kgr-profile-part v-if="!isEmpty">
        <template #heading>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-row">
                <div class="kgr-postfix__fixed">
                    <h2 class="kgr-headline kgr-headline--h3">
                        {{ $t('Notizen zu {member}', { member: memberShortProfile.firstName }) }}
                    </h2>
                </div>
            </div>
        </template>

        <template #content>
            <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--200">
                <template v-if="memberShortProfile.comment">
                    <dt
                        v-t="'Allgemein'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.comment }}
                    </dd>
                </template>
                <template v-if="memberShortProfile.bookkeepingComment">
                    <dt
                        v-t="'Buchhaltung'"
                        class="kgr-definitionList__term"
                    ></dt>
                    <dd class="kgr-definitionList__definition">
                        {{ memberShortProfile.bookkeepingComment }}
                    </dd>
                </template>
            </dl>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-part-comments',
    components: {
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        isEmpty() {
            return this.memberShortProfile.comment === '' && this.memberShortProfile.bookkeepingComment === '';
        },
    },
};
</script>
